import authHeader from "./auth-header";
import axiosInstance from "./instance";

class EmcService {
  getEmcAllUsers() {
    return axiosInstance.get("/emc_users", {
      headers: authHeader(),
    });
  }

  getEmcAllUsersAndActions() {
    return axiosInstance.get("/get_emc_users", {
      headers: authHeader(),
    });
  }

  getEmcUserLog(logParams) {
    return axiosInstance.post(
      "/get_log",
      {
        ...(logParams.date_from ? { date_from: logParams.date_from } : {}),
        ...(logParams.date_to ? { date_to: logParams.date_to } : {}),
      },
      {
        headers: authHeader(),
      }
    );
  }

  registerEmcUser(emcNewUserData) {
    return axiosInstance.post(
      "/register",
      { ...emcNewUserData },
      { headers: authHeader() }
    );
  }

  updateEmcUser(emcEditUserData) {
    return axiosInstance.put(
      "/update_emc_user",
      { ...emcEditUserData },
      { headers: authHeader() }
    );
  }

  deleteEmcUser(id) {
    return axiosInstance.put(
      "/delete_emc_user",
      {},
      {
        params: { id },
        headers: authHeader(),
      }
    );
  }
  getEmcUserPresets() {
    return axiosInstance.get("/get_emc_user_presets/", {
      headers: authHeader(),
    });
  }
}

export default new EmcService();
